import { ExamEventProctorList } from '@exam-center/exam-event-management';
import { Box, PaperSection } from '@shared/components';

export default function ExamEventProctorSection() {
  return (
    <PaperSection title='ผู้คุมสอบ'>
      <Box sx={(theme) => ({ p: theme.spacing(6) })}>
        <ExamEventProctorList />
      </Box>
    </PaperSection>
  );
}
